module.exports = __webpack_public_path__ + "fonts/Avalon-Book.9121d11.woff2";